import gsap from "@/lib/gsap";

export default function (element, dataset) {
  const listItems = element.querySelectorAll('[role="listitem"]');

  if (!listItems?.length) {
    return;
  }

  const animation = gsap.to(listItems, {
    opacity: 1,
    y: 0,
    delay: 0.5,
    duration: 1,
    ease: "back.out",
    stagger: {
      each: 0.15,
      from: "start",
    },
  });

  return () => {
    animation.kill();
  };
}
